// removed by extract-text-webpack-plugin
module.exports = {"bgGrey":"index__bgGrey___2z3g2","bold":"index__bold___NfHJY","summary":"index__summary___2c_pf","groupby-label":"index__groupby-label___11zVd"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ReportPreview/index.less
// module id = 1701
// module chunks = 3